
import modules from './modules/index.js'

// 获取模块配置项 example: getModuleConfig('router', ['member'])
let getModuleConfig = (key, selector) => {
	let selModule = getUseModule(selector)
	if(selModule.constructor === Object) {
		return selModule[key]
	}
	if(selModule.constructor === Array) {
		return selModule.map(sel => sel[key])
	}
}

// 获取选中模块 example: getUseModule('field')
let getUseModule = (selector) => {
	if(!selector) {
		return modules
	}
	if(selector.constructor === String) {
		return modules.find(item => item.moduleName == selector) || {};
	}
	if(selector.constructor === Array) {
		return modules.filter(module => selector.indexOf(module.moduleName) >= 0 )
	}
}

export default {
	getUseModule,
	getModuleConfig
}



// WEBPACK FOOTER //
// ./src/core/entry.js